import { IdentityConfigData, ThemeConfig } from 'types/config'
import {
  ConditionType,
  Gender,
  IdentitySDK,
  IdmServerErrorTypeNames,
} from '../../networking/kmp'
import { convertEnumToCloneableObject, createComputedPropertyLessClone } from '../../helpers/jsonHelper'

export interface IdentityServerResourceUrl {
    getResourcesUrl(path: string, customBase?: string | null): string
  }

export default class IdentityConfig {
  public readonly defaultPage!: string

  public readonly passKeyIconUrl!: string

  public readonly hideCloseButton!: boolean

  public readonly valueProps!: unknown[]

  public readonly terms!: Record<string, unknown>

  public readonly optIns!: Record<string, unknown>

  public readonly types!: {
      Gender: Record<string, unknown>
      ConditionType: Record<string, unknown>
      IdmServerErrorTypeNames: Record<string, unknown>
    }

  public readonly apple!: Record<string, unknown>

  public readonly google!: Record<string, unknown>

  public readonly sessionTimeout!: number

  public readonly brand!: Record<string, unknown>

  public readonly theme!: ThemeConfig

  public readonly preferences?: Record<string, unknown>

  public readonly analytics!: Record<string, unknown>

  public readonly launchdarkly!: Record<string, unknown>

  public readonly crossDomain!: Record<string, unknown>

  public readonly covatic!: Record<string, unknown>

  public readonly schemaVersion!: string

  public readonly key?: string

  public readonly language?: string

  public readonly forgeRock!: unknown

  public readonly forgotPasswordUrl!: unknown

  public readonly helpCenterUrl!: unknown

  public readonly appleRedirectUri!: unknown

  public readonly googleRedirectUri!: unknown

  constructor(
    {
      defaultPage = 'signUp',
      passKeyIconUrl = 'passkey_icon.svg',
      hideCloseButton = false,
      valueProps = [],
      terms = {},
      optIns = {},
      apple = {},
      google = {},
      sessionTimeout = 31536000,
      brand = {},
      theme = {},
      analytics = {},
      launchdarkly = {},
      crossDomain = {},
      covatic = {},
      schemaVersion = '2.0',
      language,
      preferences,
      userAcquisition,
    }: IdentityConfigData,
    server: IdentityServerResourceUrl,
    customResourceBaseUrl: string | null | undefined,
    key?: string,
  ) {
    const localTheme: ThemeConfig = { ...(theme || {}) }

    localTheme.assetsBaseUrl = server.getResourcesUrl(
      `assets/${key}/`,
      customResourceBaseUrl ?? null,
    )

    const types = {
      Gender: convertEnumToCloneableObject(Gender),
      ConditionType: convertEnumToCloneableObject(ConditionType),
      IdmServerErrorTypeNames: createComputedPropertyLessClone(IdmServerErrorTypeNames),
    }

    Object.assign(this, {
      defaultPage,
      passKeyIconUrl,
      hideCloseButton,
      valueProps,
      terms,
      optIns,
      types,
      apple,
      google,
      sessionTimeout,
      brand,
      theme: localTheme,
      preferences,
      userAcquisition,
      analytics,
      launchdarkly,
      crossDomain,
      covatic,
      schemaVersion,
      key,
      language,
      forgeRock: IdentitySDK.forgeRockConfig,
      forgotPasswordUrl: IdentitySDK.forgotPasswordUrl,
      helpCenterUrl: IdentitySDK.helpCenterUrl,
      appleRedirectUri: IdentitySDK.appleRedirectUri,
      googleRedirectUri: IdentitySDK.googleRedirectUri,
    })

    Object.freeze(this)
  }
}
